import Axios from "../../utils/axiosInstance";

export const getMyAutomatedChatSetting = () => {
    return Axios.get("/api/AutomatedChat/GetMySetting");
};

export const setAutomatedChatEnabled = (enabled) => {
    return Axios.post("/api/AutomatedChat/SetEnabled", { enabled });
};
